export default __webpack_public_path__ + "static/media/ibm.f1115859.png";